const tr = {
  activities: {
    attributes: {
      id: 'Id',
      type: 'Tipo',
      user_id: 'Usuário',
      user_name: 'Usuário',
      medical_appointment_id: 'Consulta',
      created_at: 'Criado em',
      info: 'Informações',
      platform: 'Plataforma',
      sdk_status: 'Status',
      sentiance_id: 'ID Principal Sentiance',
      sentiance_link_id: 'ID de instalação Sentiance',
      native_initialization_enabled: 'Inicialização nativa ativada?',
    },
    extras: {
      init: 'Inicializar',
      no_registers: 'Sem registros'
    },
    defSingular: 'Atividade',
    defPlural: 'Atividades',
  }
};

export default tr;
